import { getAPIErrorMessage } from 'api';
export const openErrorDialog = ({ error_ui, error, }) => ({
    type: 'ERROR_DIALOG__OPEN',
    error,
    error_ui,
});
export const openErrorDialogSimple = (e, default_msg = '') => ({
    type: 'ERROR_DIALOG__OPEN',
    error: e,
    error_ui: getAPIErrorMessage(e, default_msg),
});
export const closeErrorDialog = () => ({
    type: 'ERROR_DIALOG__CLOSE',
});
